module.exports = __webpack_public_path__ + "img/qb1.69c644d1.png";